<app-card class="page-container">
  <app-card-content>
    <div class="flex flex-column flex-align-center text-center p-xl gap-lg" data-testid="tag-link-landing">
      <app-icon name="smartphone-nfc" [size]="48" />
      <h3>{{ 'tagLink.title' | translate }}</h3>
      <p>{{ 'tagLink.message' | translate }}</p>
      <app-button (click)="getApp()" data-testid="tag-link-get-app">
        <app-icon name="download" />
        {{ 'tagLink.getApp' | translate }}
      </app-button>
      <app-button variant="outlined" (click)="continueInBrowser()" data-testid="tag-link-continue">
        {{ 'tagLink.continueInBrowser' | translate }}
      </app-button>
    </div>
  </app-card-content>
</app-card>
